import Cookies from "js-cookie";

import { errorLogger, events } from "@utilities";
import { CLASSNAMES } from "@constants";

/**
 * Handle Cookie
 *
 * @param container {HTMLElement} container element
 */

export default (container: HTMLElement) => {
  const btnClose: HTMLElement = container.querySelector(".js-cookie-close");
  const btnDecline: HTMLElement = container.querySelector(".js-cookie-decline");
  const btnAccept: HTMLElement = container.querySelector(".js-cookie-accept");

  // if session cookie active
  if (Cookies.get("HideCookiePanel") === "hide") return;

  /**
   * Inject "__RequestVerificationToken" header needed by Kentico against
   * Cross-Site Request Forgery.
   */
  const getCSRFToken = () => {
    const token = (window.WIDGETS_CONFIG?.general as General)?.requestVerificationToken ?? "";

    if (!token) {
      console.error('Missing "requestVerificationToken" in general config!');
    }

    return token;
  };

  // Animate cookie bar after DOM loaded
  events.on(window, { DOMContentLoaded: () => container.classList.add(CLASSNAMES.ACTIVE) });

  const hideCookie = () => {
    container.classList.remove("active");
  };

  const setCookie = async (cookieType: boolean) => {
    const data = { acceptAllCookies: cookieType };
    try {
      await fetch(`${window.location.origin}/api/Cookie/Update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          __RequestVerificationToken: getCSRFToken(),
        },
        body: JSON.stringify(data),
      }).then(() => {
        hideCookie();
      });
    } catch (error) {
      errorLogger(error);
    }
  };

  const setDataLayer = (element) => {
    const { dataLayer } = window;

    const cookieleConfig = {
      event: `${element.dataset.cookieConsentEvent}`,
      preferential: `${element.dataset.cookieConsentPreferential}`,
      analytical: `${element.dataset.cookieConsentAnalytical}`,
      marketing: `${element.dataset.cookieConsentMarketing}`,
      technical: `${element.dataset.cookieConsentTechnical}`,
      storageConsentsContext:
      {
        consentSelectionMethod: `${element.dataset.cookieConsentConsentselectionmethod}`,
        functionalStorageAllowed: `${element.dataset.cookieConsentPreferential}`,
        statisticsStorageAllowed: `${element.dataset.cookieConsentAnalytical}`,
        marketingStorageAllowed: `${element.dataset.cookieConsentMarketing}`,
        technicalStorageAllowed: `${element.dataset.cookieConsentTechnical}`,
      }
    };
    dataLayer.push(cookieleConfig);
  };

  const updateMeiro = (cookieType: boolean) => {
    try {
      if (window.MeiroEvents) {
        window.MeiroEvents.updateStorageConsent({ statistics: cookieType });
      }
    } catch (error) {
      errorLogger(error);
    }
  };

  events.on(btnAccept, {
    click: () => {
      setCookie(true);
      updateMeiro(true);
      setDataLayer(btnAccept);
    },
  });

  events.on(btnDecline, {
    click: () => {
      setCookie(false);
      updateMeiro(false);
      setDataLayer(btnDecline);
    },
  });

  events.on(btnClose, {
    click: () => {
      Cookies.set("HideCookiePanel", "hide");
      hideCookie();
      setDataLayer(btnClose);
    },
  });
};
